import Icon from '../components/Icon.vue'

Icon.register({"truck-loading":{"width":640,"height":512,"paths":[{"d":"M50.2 375.6C52.5 384.1 61.3 389.2 69.8 386.9L286.2 328.9C294.7 326.6 299.8 317.8 297.5 309.3L247.8 123.8C245.5 115.3 236.7 110.2 228.2 112.5L151 133.3 175.8 226 114 242.5 89.2 149.8 11.9 170.5C3.4 172.8-1.7 181.6 0.6 190.1L50.2 375.6zM384 0C366.3 0 352 14.3 352 32V355.6L5.9 450C1.6 451.2-0.9 455.6 0.3 459.8L12.9 506.1C14.1 510.4 18.5 512.9 22.7 511.7L416.4 404.3C418.8 464.1 467.6 512 528 512 589.9 512 640 461.9 640 400V0H384zM528 448C501.5 448 480 426.5 480 400S501.5 352 528 352 576 373.5 576 400 554.5 448 528 448z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/truck-loading.js
// module id = null
// module chunks = 